'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EventTypes = {
  identify: 'identify',
  page: 'page',
  track: 'track',
  alias: 'alias',
  group: 'group',
  reset: 'reset'
};

exports.default = EventTypes;


//////////////////
// WEBPACK FOOTER
// ./~/redux-segment/dist/event/types.js
// module id = 612
// module chunks = 10